// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__g01tm","tooltiptext":"Tooltip_tooltiptext__pC4Ad"};